import styled from 'styled-components';

export const Section = styled.div`
  width: 100%;
  padding-top: 64px;
  padding-bottom: 64px;

  @media (max-width: 900px) {
    padding-top: 32px;
    padding-bottom: 50px;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column-reverse;
    justify-center: space-between;
    gap: 45px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;

  width: 100%;

  @media (max-width: 900px) {
    padding-right: 32px;
    padding-left: 32px;
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: 0;
  color: #004f92;

  max-width: 298px;

  @media (max-width: 900px) {
    font-size: 32px;
    line-height: 40px;

    max-width: 100%;
  }
`;

export const Description = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  color: #898b8e;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 326px;

  padding-top: 8px;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

export const ImageSection = styled.img`
  max-width: 644px;
  max-height: 510px;

  @media (max-width: 900px) {
    margin-left: -32px;
    max-width: 100%;
    max-height: 332px;
  }
`;
